/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Inject, Injectable, OnDestroy} from '@angular/core';
import {getDOM} from './dom_adapter';
import {DOCUMENT} from './dom_tokens';
export class SharedStylesHost {
/**
 * \@internal
 */
protected _stylesSet = new Set<string>();
/**
 * @param {?} styles
 * @return {?}
 */
addStyles(styles: string[]): void {
    const /** @type {?} */ additions = new Set<string>();
    styles.forEach(style => {
      if (!this._stylesSet.has(style)) {
        this._stylesSet.add(style);
        additions.add(style);
      }
    });
    this.onStylesAdded(additions);
  }
/**
 * @param {?} additions
 * @return {?}
 */
onStylesAdded(additions: Set<string>): void {}
/**
 * @return {?}
 */
getAllStyles(): string[] { return Array.from(this._stylesSet); }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SharedStylesHost_tsickle_Closure_declarations() {
/** @type {?} */
SharedStylesHost.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SharedStylesHost.ctorParameters;
/**
 * \@internal
 * @type {?}
 */
SharedStylesHost.prototype._stylesSet;
}

export class DomSharedStylesHost extends SharedStylesHost implements OnDestroy {
private _hostNodes = new Set<Node>();
private _styleNodes = new Set<Node>();
/**
 * @param {?} _doc
 */
constructor(
private _doc: any) {
    super();
    this._hostNodes.add(_doc.head);
  }
/**
 * @param {?} styles
 * @param {?} host
 * @return {?}
 */
private _addStylesToHost(styles: Set<string>, host: Node): void {
    styles.forEach((style: string) => {
      const /** @type {?} */ styleEl = this._doc.createElement('style');
      styleEl.textContent = style;
      this._styleNodes.add(host.appendChild(styleEl));
    });
  }
/**
 * @param {?} hostNode
 * @return {?}
 */
addHost(hostNode: Node): void {
    this._addStylesToHost(this._stylesSet, hostNode);
    this._hostNodes.add(hostNode);
  }
/**
 * @param {?} hostNode
 * @return {?}
 */
removeHost(hostNode: Node): void { this._hostNodes.delete(hostNode); }
/**
 * @param {?} additions
 * @return {?}
 */
onStylesAdded(additions: Set<string>): void {
    this._hostNodes.forEach(hostNode => this._addStylesToHost(additions, hostNode));
  }
/**
 * @return {?}
 */
ngOnDestroy(): void { this._styleNodes.forEach(styleNode => getDOM().remove(styleNode)); }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [DOCUMENT, ] }, ]},
];
}

function DomSharedStylesHost_tsickle_Closure_declarations() {
/** @type {?} */
DomSharedStylesHost.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DomSharedStylesHost.ctorParameters;
/** @type {?} */
DomSharedStylesHost.prototype._hostNodes;
/** @type {?} */
DomSharedStylesHost.prototype._styleNodes;
/** @type {?} */
DomSharedStylesHost.prototype._doc;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/platform-browser/src/dom/shared_styles_host.ts